module.exports = __webpack_public_path__ + "static/media/invest.f5bb3772.png";